module.exports = function(video) {
	"use strict";
  video
  .controller('videoCategoriesController', videoCategoriesController)
	videoCategoriesController.$inject = ["watchAllCheckboxesNgTable","checkArray","$stateParams","$state","$scope","$rootScope","NgTableParams", "getDataService","refreshtokenService","$filter","postDataService","alertService","reqursiveService","jQuery","deleteDataService","putDataService","serverError","comunicateBetweenViews","offlineError"]
	
  function videoCategoriesController(watchAllCheckboxesNgTable,checkArray,$stateParams,$state,$scope,$rootScope, NgTableParams,getDataService,refreshtokenService,$filter,postDataService,alertService,reqursiveService,jQuery, deleteDataService,putDataService,serverError, comunicateBetweenViews,offlineError) {
    var vmvc = this;
    var state = 'video-categories';
    vmvc.categoryEdit = false;
    $rootScope.alert={hasBeenShown: false};
    $rootScope.hasLoaded = false;
    vmvc.selectedName = -1;
    vmvc.nameRequired = false;
    vmvc.checkboxes = { 'checked': false, items: {} };
    var $data;
    var s;
    var search;
    var tree;
    vmvc.categoryName = undefined;
    vmvc.categorySlug = undefined;
    vmvc.categoryDescription= undefined;
    vmvc.selectedBulkAction = {value: 'default'};
    vmvc.checkedPostsEdit = [];
    vmvc.checkboxes = { items: {} };
    vmvc.categoryId = $stateParams.id; 
    if($stateParams.id) {
      vmvc.categoryEdit = true;
    } else {
      vmvc.categoryEdit = false;
    }
    // add new category
    vmvc.addNewCategory = function() {
      if(vmvc.selectedCategory.value =='none') {
        vmvc.selectedCategory.value = undefined;
      }
      if(vmvc.categoryName) {
        var postFunction = function() {  
          postDataService.save({
            param1: state, 
            param2: 'create'
          },{
            'name':vmvc.categoryName,
            'parent': vmvc.selectedCategory.value,
            "description": vmvc.categoryDescription,
            'slug':vmvc.categorySlug
          }).$promise.then(function(postCategory){
            vmvc.categoryName = undefined;
            vmvc.categorySlug = undefined;
            vmvc.categoryDescription= undefined;
            vmvc.selectedCategory.value ='none';
            alertService('success','Success ', postCategory.message, 2000);
            vmvc.getCategories();
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            } 
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    postFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                 // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else {
              alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
              if(error && error.data && error.data.error && error.data.error.slug) {
                vmvc.categorySlug = error.data.error.slug;
              }
              vmvc.selectedCategory.value ='none';
            } 
          });
        }
        postFunction();
      } else {
        vmvc.selectedCategory.value ='none';
        alertService('danger','Opps! ', 'Category name is required')
        vmvc.nameRequired=true;
      }
    }
    vmvc.goToAllPosts = function(category) {
      comunicateBetweenViews.setCategory(category);
      $state.go('app.allvideos'); 
    }
    vmvc.quickEdit = function(id) {
      vmvc.selectedName = id;
    }
    vmvc.cancelQuickEdit = function() {
      vmvc.selectedName = -1;
    }
    vmvc.editCategory = function(categoryId) {
      vmvc.categoryEdit= true;
      jQuery("html, body").animate({
        scrollTop: 0
      }, 10);
      vmvc.categoryId = categoryId;
      $state.transitionTo('app.video_categories', {id: vmvc.categoryId}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vmvc.updateBulkDeleteSuccess = function() {
      watchAllCheckboxesNgTable.resetCheckBox(vmvc)
      vmvc.selectedBulkAction = {value: 'default'};
      vmvc.searchData = {name:''};
      vmvc.getCategories('update'); 
    }
    watchAllCheckboxesNgTable.watch($scope,vmvc)
    vmvc.checkedPost = function(categoryId, checked) {
      if(checked) {
        vmvc.checkedPostsEdit.push(categoryId);
      } else {

        if(vmvc.checkedPostsEdit.includes(categoryId)) {
          var id_tag = categoryId;
          var position = vmvc.checkedPostsEdit.indexOf(id_tag);
          vmvc.checkedPostsEdit.splice(position, 1);
        }
      }
    }
    var tablePopulateFunction = function() {
      vmvc.tableParams = new NgTableParams({
        page: 1,
        count: 20,
       
        }, {
          total:vmvc.categoriesTreeInput.length,
        getData: function(params) {
          $data = vmvc.categoriesTreeInput; 
          $data = params.sorting() ?
          $filter('orderBy')($data, params.orderBy()) : $data;
          $data = $data.slice((params.page() - 1) * params.count(), params.page() * params.count());
          vmvc.dataGet = $data;
          jQuery('.goTo input').val("");
          watchAllCheckboxesNgTable.resetCheckBox(vmvc)
          if(vmvc.categoriesTreeInput.length == 0) {
              $rootScope.emptyTable = true;
            } else {
              $rootScope.emptyTable = false;
            } 
          return $data; 
        }    
      });  
    }
    vmvc.dataCategoryFunction = function(update) {
      vmvc.categoryTreeFunction= function() {
        vmvc.categoriesTreeInput = reqursiveService.getReqursiveArray(vmvc.data);
        vmvc.copycategoriesTreeInput = angular.copy(vmvc.categoriesTreeInput);
        vmvc.categoriesTreeSelect = angular.copy(vmvc.categoriesTreeInput);
        for(var i=0; i< vmvc.categoriesTreeSelect.length; i++) {
          var n = (vmvc.categoriesTreeSelect[i].ancestors.length)*2;
          var empty = "\u00A0";
          for(var j=0;j<n;j++) {
            vmvc.categoriesTreeSelect[i].name = empty+vmvc.categoriesTreeSelect[i].name;
          }
        }
      }
      vmvc.categoryTreeFunction();
      vmvc.selectedCategory= {value: 'none'};
      if(update) {
        vmvc.tableParams.reload()
      } else {
        tablePopulateFunction()
      }
    }
    vmvc.changeSearch = function(searchData) {
      vmvc.categoriesTreeInput = (searchData.name)? reqursiveService.getReqursiveArray($filter('filter')(vmvc.copycategoriesTreeInput,searchData)) : vmvc.copycategoriesTreeInput; 
      vmvc.categoriesTreeInput = checkArray.removeObjArryDuplicate(vmvc.categoriesTreeInput)
      tablePopulateFunction()
    }
    vmvc.getCategories = function(update) {
      var getCategoriesFunction = function() {
        getDataService.get({param1: state, param2: null,tree:tree}).$promise.then(function(data){
          vmvc.data = data.categories;
          vmvc.dataCategoryFunction(update);
          $rootScope.hasLoaded = true;
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getCategoriesFunction();
                }
              },
              function(error) {
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else if(error.status ==404) {
            $rootScope.emptyTable = true;
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        }); 
      }
      getCategoriesFunction();
    }
    vmvc.getCategories();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video-categories/js/videoCategoriesController.js
// module id = 651
// module chunks = 0